<template>
  <AppPage>
    <AppHeader
        title="ENTRADA DE USUARIOS"
        left-icon="question-circle"
        :left-action="()=>$router.push('/help')"
        :hide-right="true"
    />
    <!-- <div class="logo text-center">
      <img src="http://immsoluciones.com/wp-content/uploads/2018/02/HB_gris.png">
    </div> -->
    <AppSection title="CON TUS REDES SOCIALES">
      <LoginSocial />
      <div class="text-muted danger fs-2 social-msg">
        Nunca vamos a publicar algo sin tu permiso.
        <br>
        Valoramos tu privacidad tanto como si fuera la nuestra.
      </div>
    </AppSection>
    <AppSection title="CON TU EMAIL Y CONTRASEÑA">
      <LoginForm @userRegister="onUserRegister" @userAuth="onUserLogin" />
    </AppSection>
    <!--     <AppSection class="text-center">
          <div class="alert alert-success text-center" @click="onAnonymousLogin">
            <i class="fa fa-cart-plus" />
            <br>
            <span>
              Pulsa sobre este mensaje empezar sin identificarte
            </span>
          </div>
        </AppSection>

        <div class="text-muted info">
          Si ya eres usuario puedes entrar con tú perfil.
          <br>
          Si aún no te has dado de alta, pues hacerlo ahora.
        </div>

        <AppSection title="CON TUS REDES SOCIALES">
          <LoginSocial />
          <div class="text-muted danger">
            Nunca vamos a publicar algo sin tu permiso.
            <br>
            Valoramos tu privacidad tanto como si fuera la nuestra.
          </div>
        </AppSection>
         -->
  </AppPage>
</template>

<script>
import { mapMutations } from 'vuex'
import firebase from 'firebase'
import { usersRef } from '../../firebase'
import LoginSocial from './LoginSocial'
import LoginForm from './LoginForm'
import NewOrderMessage from '../Order/NewOrderMessage'

export default {
  components: { NewOrderMessage, LoginSocial, LoginForm },
  mounted() {},
  methods: {
    ...mapMutations({
      isLoading: 'isLoading',
      setError: 'setError',
      setUserProfile: 'setUserProfile'
    }),
    onUserRegister(userData) {
      this.isLoading(true)
      const { email, password } = userData
      firebase
        .auth()
        .createUserWithEmailAndPassword(email, password)
        .catch(error => this.setError(error.message))
    },
    onUserLogin(userData) {
      this.isLoading(true)
      const { email, password } = userData
      firebase
        .auth()
        .signInWithEmailAndPassword(email, password)
        .then(user => {
          if (user) {
            usersRef
              .child(user.uid)
              .child('user')
              .once('value', () => {})
              .then(snap => {
                const userData = snap.val()
                console.log(userData)
                if (userData) {
                  const profile = {
                    uid: user.uid,
                    email: userData.email || '',
                    displayName: userData.displayName || '',
                    photoURL: userData.photoURL || ''
                  }
                  this.setUserProfile({ user: profile })
                } else {
                  const profile = {
                    uid: user.uid,
                    email: user.email || '',
                    displayName: user.displayName || '',
                    photoURL: user.photoURL || ''
                  }
                  usersRef
                    .child(user.uid)
                    .child('user')
                    .set(profile)
                    .then(() => {
                      this.setUserProfile({ user: profile })
                    })
                }
              })
              .catch(error => this.setError(error.message))
          } else {
            this.setUserProfile(null)
          }
        })
        .catch(error => this.setError(error.message))
    },
    onAnonymousLogin() {
      this.$store.commit('isLoading', true)
      firebase
        .auth()
        .signInAnonymously()
        .catch(err => {
          this.setError(err.message)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.logo {
  img {
    width: 120px;
  }
  @media screen and (max-width: 340px) {
    img {
      width: 60px;
    }
  }
}

.info {
  padding: 0.4rem 1rem 1rem 1rem;
  text-align: center;
}

.danger {
  font-size: 0.92rem;
  padding: 1rem 1rem 0 1rem;
  text-align: center;
  @media screen and (max-width: 340px) {
    font-size: 0.82rem;
    padding: 0.82rem 0.2rem 0 0.2rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/User/UserLogin.vue